import React, { Fragment, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

//components
import ThemeMenuThree from '../../../components/header/ThemeMenuThree'
import PageTitle from '../../../components/page-title/PageTitle'
import FeatureFour from '../../../components/feature/FeatureFour'
import NewsletterTwo from '../../../components/call-to-action/NewsletterTwo'
import FooterThree from '../../../components/footer/FooterThree'


const Services = () => {
    const location = useLocation()

    useEffect(() => {
        const id = location.hash?.replace(/^#/, '')
        if (!id) return
        const run = () => {
            const el = document.getElementById(id)
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
        const t = window.requestAnimationFrame(() => {
            window.requestAnimationFrame(run)
        })
        return () => window.cancelAnimationFrame(t)
    }, [location.pathname, location.hash])

    return (
        <Fragment>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="서비스" />
                {/* PageTitle */}

                {/*our-services start*/}
                <section className="our-services codam-services-page service-bg-two pt-145 pb-100 pt-lg-60 pb-lg-20">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                            <div className="col-xl-8 col-lg-9 col-md-10">
                                <div className="section-title text-center mb-55">
                                    <h3 className="sect-title mb-25" data-aos="fade-up">서비스 소개</h3>
                                    <p data-aos="fade-up" data-aos-delay={100}>
                                        멀티테넌트·구독 기반 B2B SaaS와 권한·모니터링을 갖춘 관리자 시스템, API·마이크로서비스
                                        백엔드로 확장 가능한 플랫폼을 설계합니다. SAP·Oracle 등 ERP·그룹웨어 연동과 데이터 수집·BI로
                                        의사결정을 돕고, 성능 분석과 리팩토링·클라우드 마이그레이션으로 운영을 이어 줍니다. 브랜드에 맞는
                                        캐릭터·IP, 현장 장비까지 산업 디자인(CMF), 사용자 경험과 프로토타입을 잇는 제품 디자인까지
                                        전 과정에서 함께합니다.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <FeatureFour />
                    </div>
                </section>
                {/*our-services end*/}


                {/*codam-newsletter start*/}
                <NewsletterTwo />
                {/*codam-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default Services